var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from "react";
import { AlertOctagonIcon, AlertTriangleIcon, CheckCircleIcon, InfoIcon } from "../../icons/index.js";
import renderIcon from "../../icons/render-icon.js";
import makeStyles from "../../theming/make-styles.js";
import Button from "../button/index.js";
import LinearProgress from "../linear-progress/index.js";
import Dialog, { DialogBody, DialogFooter, DialogHeader } from "./index.js";
export const useStyles = makeStyles()(theme => ({
    body: {
        paddingTop: 0,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
    dialog: {
        textAlign: "center",
    },
    footer: {
        "display": "flex",
        "flexDirection": "row",
        "justifyContent": "center",
        "padding": theme.spacing(0, "lg", "lg"),
        "& button": {
            "&:first-child": {
                flex: "1 0 fit-content",
            },
        },
        "& button + button": {
            flex: "1 1 fit-content",
            marginLeft: theme.spacing("sm"),
        },
    },
    header: {
        position: "relative",
        paddingBottom: theme.spacing("sm"),
        borderBottom: 0,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
    icon: {
        "padding": theme.spacing("sm"),
        "marginBottom": theme.spacing(12),
        "borderRadius": "100%",
        "& > svg": {
            display: "block",
        },
    },
    loading: {
        position: "absolute",
        top: 0,
        right: 0,
        left: 0,
        zIndex: 1,
    },
}));
const icons = {
    primary: InfoIcon,
    warning: AlertTriangleIcon,
    success: CheckCircleIcon,
    error: AlertOctagonIcon,
};
function EmptyCloseButton() {
    return null;
}
export function AlertDialog(_a) {
    var { cancelLabel, children, color = "primary", confirmDisabled, confirmLabel, hideFooter = false, icon = icons[color] || null, loading, open, size = "small", title, onCancel, onClose, onConfirm } = _a, props = __rest(_a, ["cancelLabel", "children", "color", "confirmDisabled", "confirmLabel", "hideFooter", "icon", "loading", "open", "size", "title", "onCancel", "onClose", "onConfirm"]);
    const { classes } = useStyles();
    const handleCancel = useCallback((e) => {
        onCancel === null || onCancel === void 0 ? void 0 : onCancel(e);
        onClose === null || onClose === void 0 ? void 0 : onClose(e);
    }, [onCancel, onClose]);
    const handleConfirm = useCallback((e) => __awaiter(this, void 0, void 0, function* () {
        yield (onConfirm === null || onConfirm === void 0 ? void 0 : onConfirm(e));
        onClose === null || onClose === void 0 ? void 0 : onClose(e);
    }), [onClose, onConfirm]);
    return (_jsxs(Dialog, Object.assign({ className: classes.dialog, "data-component": "alert-dialog", open: open, role: "alertdialog", size: size, onClose: onClose }, props, { children: [_jsxs(DialogHeader, { className: classes.header, closeButton: EmptyCloseButton, children: [loading && (_jsx("div", { className: classes.loading, children: _jsx(LinearProgress, { indeterminate: true }) })), icon && _jsx("div", { className: classes.icon, children: renderIcon(icon, undefined, { color }) }), _jsx("h3", { children: title })] }), _jsx(DialogBody, { className: classes.body, children: children }), !hideFooter && (_jsxs(DialogFooter, { className: classes.footer, children: [_jsx(Button, { block: true, color: "text", "data-action": "cancel", variant: "link", onClick: handleCancel, children: cancelLabel }), _jsx(Button, { block: true, color: color, "data-action": "confirm", disabled: loading || confirmDisabled, onClick: handleConfirm, children: confirmLabel })] }))] })));
}
export default AlertDialog;
//# sourceMappingURL=alert-dialog.js.map